export default __webpack_public_path__ + "static/media/home-section-how-works.e0d4bfe8.png";